import { ReactElement } from 'react';

import styles from './styles.module.scss';

interface LogoContainerProps {
  logo: string;
  paymentMethodName: string;
}

export const PaymentMethodLogo = ({
  logo,
  paymentMethodName,
}: LogoContainerProps): ReactElement => (
  <div className={styles.wrapper}>
    <div className={styles.paymentName}>{paymentMethodName}</div>
    <img src={logo} alt={paymentMethodName} data-test="payment-logo" />
  </div>
);
